var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-wrap"
  }, [_c('ValidationObserver', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return handleSubmit(_vm.updateContactInfo);
            }
          }
        }, [_c('h2', [_vm._v("Contact Information")]), _c('p', [_vm._v("Enter and Update all your Contact Information here")]), _c('div', {
          staticClass: "info-form mb-4"
        }, [_c('div', {
          staticClass: "form-group row"
        }, [_vm.contactFormFields.email_address ? _c('div', {
          staticClass: "col-xxl-3 col-lg-3 col-md-6 mb-3"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": _vm.getRules(_vm.contactFormFields['email_address']),
            "custom-messages": _vm.getErrorMessages('email_address')
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref2) {
              var errors = _ref2.errors;
              return [_c('label', {
                attrs: {
                  "for": "email_address"
                }
              }, [_vm._v(" Email (Must be client's email) "), _vm.contactFormFields['email_address']['required'] ? _c('span', {
                staticClass: "required"
              }, [_vm._v("*")]) : _vm._e()]), _c('input', {
                directives: [{
                  name: "model",
                  rawName: "v-model",
                  value: _vm.contactPostData['email_address'],
                  expression: "contactPostData['email_address']"
                }],
                staticClass: "info-field",
                attrs: {
                  "id": "email_address"
                },
                domProps: {
                  "value": _vm.contactPostData['email_address']
                },
                on: {
                  "input": function input($event) {
                    if ($event.target.composing) { return; }

                    _vm.$set(_vm.contactPostData, 'email_address', $event.target.value);
                  }
                }
              }), _c('span', {
                staticClass: "text-danger"
              }, [_vm._v(_vm._s(errors[0]))])];
            }
          }], null, true)
        }), _vm.showOtpSectionEmail ? _c('span', {
          staticClass: "validate-btn col-md-5 col-sm-6 d-flex "
        }, [_c('a', {
          staticClass: "validate-via-otp-link ",
          staticStyle: {
            "color": "blue"
          },
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.openOtpModal('email');
            }
          }
        }, [_vm._v(" Validate via OTP ")])]) : _vm._e(), _vm.emailMsg ? _c('div', {
          staticClass: "contact-message-container form-group",
          staticStyle: {
            "margin-top": "3px"
          }
        }, [_c('div', {
          class: ['validate-message', _vm.emailValidationMessage.type]
        }, [_c('div', {
          class: ['message-indicator', "".concat(_vm.emailValidationMessage.type, "-indicator")]
        }), _c('span', {
          staticClass: "message-text"
        }, [_c('strong', {
          class: "".concat(_vm.emailValidationMessage.type, "-text")
        }, [_vm._v(_vm._s(_vm.emailValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.emailValidationMessage.message) + " ")])])]) : _vm._e()], 1) : _vm._e(), _vm.contactFormFields.phone_number ? _c('div', {
          staticClass: "col-xxl-3 col-lg-3 col-md-6 mb-3"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": _vm.getRules(_vm.contactFormFields['phone_number']),
            "custom-messages": _vm.getErrorMessages('phone_number')
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref3) {
              var errors = _ref3.errors;
              return [_c('label', {
                attrs: {
                  "for": "phone_number"
                }
              }, [_vm._v(" Contact Number "), _vm.contactFormFields['phone_number']['required'] ? _c('span', {
                staticClass: "required"
              }, [_vm._v("*")]) : _vm._e()]), _c('input', {
                directives: [{
                  name: "model",
                  rawName: "v-model",
                  value: _vm.contactPostData['phone_number'],
                  expression: "contactPostData['phone_number']"
                }],
                staticClass: "info-field",
                attrs: {
                  "id": "phone_number",
                  "inputmode": "numeric",
                  "pattern": "\\d*"
                },
                domProps: {
                  "value": _vm.contactPostData['phone_number']
                },
                on: {
                  "input": [function ($event) {
                    if ($event.target.composing) { return; }

                    _vm.$set(_vm.contactPostData, 'phone_number', $event.target.value);
                  }, _vm.onPhoneInput]
                }
              }), _c('span', {
                staticClass: "text-danger"
              }, [_vm._v(_vm._s(errors[0]))])];
            }
          }], null, true)
        }), _vm.showOtpSectionPhone ? _c('span', {
          staticClass: "validate-btn col-md-5 col-sm-6 d-flex "
        }, [_c('a', {
          staticClass: "validate-via-otp-link ",
          staticStyle: {
            "color": "blue"
          },
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.openOtpModal('phone');
            }
          }
        }, [_vm._v(" Validate via OTP ")])]) : _vm._e(), _vm.phoneMsg ? _c('div', {
          staticClass: "contacts-message-container form-group",
          staticStyle: {
            "margin-top": "3px"
          }
        }, [_c('div', {
          class: ['validate-message', _vm.phoneValidationMessage.type]
        }, [_c('div', {
          class: ['message-indicator', "".concat(_vm.phoneValidationMessage.type, "-indicator")]
        }), _c('span', {
          staticClass: "message-text"
        }, [_c('strong', {
          class: "".concat(_vm.phoneValidationMessage.type, "-text")
        }, [_vm._v(_vm._s(_vm.phoneValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.phoneValidationMessage.message) + " ")])])]) : _vm._e()], 1) : _vm._e()]), _c('div', {
          staticClass: "form-group row"
        }, [_vm.contactFormFields.address1 ? _c('div', {
          staticClass: "col-xxl-3 col-lg-3 col-md-6 mb-3"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": _vm.getRules(_vm.contactFormFields['address1']),
            "custom-messages": _vm.getErrorMessages('address1')
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref4) {
              var errors = _ref4.errors;
              return [_c('label', {
                attrs: {
                  "for": "address1"
                }
              }, [_vm._v(" Street Address "), _vm.contactFormFields['address1']['required'] ? _c('span', {
                staticClass: "required"
              }, [_vm._v("*")]) : _vm._e()]), _c('input', {
                directives: [{
                  name: "model",
                  rawName: "v-model",
                  value: _vm.contactPostData['address1'],
                  expression: "contactPostData['address1']"
                }],
                staticClass: "info-field",
                attrs: {
                  "id": "address1"
                },
                domProps: {
                  "value": _vm.contactPostData['address1']
                },
                on: {
                  "input": function input($event) {
                    if ($event.target.composing) { return; }

                    _vm.$set(_vm.contactPostData, 'address1', $event.target.value);
                  }
                }
              }), _c('span', {
                staticClass: "text-danger"
              }, [_vm._v(_vm._s(errors[0]))])];
            }
          }], null, true)
        })], 1) : _vm._e(), _vm.contactFormFields.address2 ? _c('div', {
          staticClass: "col-xxl-3 col-lg-3 col-md-6 mb-3"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": _vm.getRules(_vm.contactFormFields['address2']),
            "custom-messages": _vm.getErrorMessages('address2')
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref5) {
              var errors = _ref5.errors;
              return [_c('label', {
                attrs: {
                  "for": "address2"
                }
              }, [_vm._v(" Apt/Suite/Other "), _vm.contactFormFields['address2']['required'] ? _c('span', {
                staticClass: "required"
              }, [_vm._v("*")]) : _vm._e()]), _c('input', {
                directives: [{
                  name: "model",
                  rawName: "v-model",
                  value: _vm.contactPostData['address2'],
                  expression: "contactPostData['address2']"
                }],
                staticClass: "info-field",
                attrs: {
                  "id": "address2"
                },
                domProps: {
                  "value": _vm.contactPostData['address2']
                },
                on: {
                  "input": function input($event) {
                    if ($event.target.composing) { return; }

                    _vm.$set(_vm.contactPostData, 'address2', $event.target.value);
                  }
                }
              }), _c('span', {
                staticClass: "text-danger"
              }, [_vm._v(_vm._s(errors[0]))])];
            }
          }], null, true)
        })], 1) : _vm._e(), _vm.contactFormFields.city ? _c('div', {
          staticClass: "col-xxl-3 col-lg-3 col-md-6 mb-3"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": _vm.getRules(_vm.contactFormFields['city']),
            "custom-messages": _vm.getErrorMessages('city')
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref6) {
              var errors = _ref6.errors;
              return [_c('label', {
                attrs: {
                  "for": "city"
                }
              }, [_vm._v(" City "), _vm.contactFormFields['city']['required'] ? _c('span', {
                staticClass: "required"
              }, [_vm._v("*")]) : _vm._e()]), _c('input', {
                directives: [{
                  name: "model",
                  rawName: "v-model",
                  value: _vm.contactPostData['city'],
                  expression: "contactPostData['city']"
                }],
                staticClass: "info-field",
                attrs: {
                  "id": "city"
                },
                domProps: {
                  "value": _vm.contactPostData['city']
                },
                on: {
                  "input": function input($event) {
                    if ($event.target.composing) { return; }

                    _vm.$set(_vm.contactPostData, 'city', $event.target.value);
                  }
                }
              }), _c('span', {
                staticClass: "text-danger"
              }, [_vm._v(_vm._s(errors[0]))])];
            }
          }], null, true)
        })], 1) : _vm._e(), _vm.contactFormFields.state ? _c('div', {
          staticClass: "col-xxl-3 col-lg-3 col-md-6 mb-3"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": _vm.getRules(_vm.contactFormFields['state']),
            "custom-messages": _vm.getErrorMessages('state')
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref7) {
              var errors = _ref7.errors;
              return [_c('label', {
                attrs: {
                  "for": "state"
                }
              }, [_vm._v(" State "), _vm.contactFormFields['state']['required'] ? _c('span', {
                staticClass: "required"
              }, [_vm._v("*")]) : _vm._e()]), _c('select', {
                directives: [{
                  name: "model",
                  rawName: "v-model",
                  value: _vm.contactPostData['state'],
                  expression: "contactPostData['state']"
                }],
                staticClass: "info-field",
                attrs: {
                  "id": "state",
                  "disabled": ""
                },
                on: {
                  "change": function change($event) {
                    var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
                      return o.selected;
                    }).map(function (o) {
                      var val = "_value" in o ? o._value : o.value;
                      return val;
                    });

                    _vm.$set(_vm.contactPostData, 'state', $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
                  }
                }
              }, _vm._l(_vm.contactFormFields['state']['options'], function (option, index1) {
                return _c('option', {
                  key: index1,
                  attrs: {
                    "id": option.index1
                  },
                  domProps: {
                    "value": option.value
                  }
                }, [_vm._v(" " + _vm._s(option.name) + " ")]);
              }), 0), _c('span', {
                staticClass: "text-danger"
              }, [_vm._v(_vm._s(errors[0]))])];
            }
          }], null, true)
        })], 1) : _vm._e(), _vm.contactFormFields.zip ? _c('div', {
          staticClass: "col-xxl-3 col-lg-3 col-md-6 mb-3"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": _vm.getRules(_vm.contactFormFields['zip']),
            "custom-messages": _vm.getErrorMessages('zip')
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref8) {
              var errors = _ref8.errors;
              return [_c('label', {
                attrs: {
                  "for": "zip"
                }
              }, [_vm._v(" Zip code "), _vm.contactFormFields['zip']['required'] ? _c('span', {
                staticClass: "required"
              }, [_vm._v("*")]) : _vm._e()]), _c('input', {
                directives: [{
                  name: "model",
                  rawName: "v-model",
                  value: _vm.contactPostData['zip'],
                  expression: "contactPostData['zip']"
                }],
                staticClass: "info-field",
                attrs: {
                  "id": "zip",
                  "disabled": ""
                },
                domProps: {
                  "value": _vm.contactPostData['zip']
                },
                on: {
                  "input": function input($event) {
                    if ($event.target.composing) { return; }

                    _vm.$set(_vm.contactPostData, 'zip', $event.target.value);
                  }
                }
              }), _c('span', {
                staticClass: "text-danger"
              }, [_vm._v(_vm._s(errors[0]))])];
            }
          }], null, true)
        })], 1) : _vm._e()]), _c('div', {
          staticClass: "form-group row"
        }, [_vm.contactFormFields.with_validation ? _c('div', {
          staticClass: "form-check col-xxl-6 col-lg-6 col-md-6 mb-3"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.contactPostData['with_validation'],
            expression: "contactPostData['with_validation']"
          }],
          staticClass: "form-check-input",
          attrs: {
            "type": "checkbox",
            "id": "with_validation"
          },
          domProps: {
            "checked": Array.isArray(_vm.contactPostData['with_validation']) ? _vm._i(_vm.contactPostData['with_validation'], null) > -1 : _vm.contactPostData['with_validation']
          },
          on: {
            "change": function change($event) {
              var $$a = _vm.contactPostData['with_validation'],
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false;

              if (Array.isArray($$a)) {
                var $$v = null,
                    $$i = _vm._i($$a, $$v);

                if ($$el.checked) {
                  $$i < 0 && _vm.$set(_vm.contactPostData, 'with_validation', $$a.concat([$$v]));
                } else {
                  $$i > -1 && _vm.$set(_vm.contactPostData, 'with_validation', $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                }
              } else {
                _vm.$set(_vm.contactPostData, 'with_validation', $$c);
              }
            }
          }
        }), _c('label', {
          staticClass: "form-check-label",
          attrs: {
            "for": "flexCheckDefault"
          }
        }, [_vm._v(" USPS Address Validation ")])]) : _vm._e()]), _c('div', {
          staticClass: "row justify-content-end mt-3"
        }, [_c('div', {
          staticClass: "col-xxl-3 col-xl-3 col-lg-3 col-md-6"
        }, [_c('button', {
          staticClass: "univ-btn",
          staticStyle: {
            "max-width": "100% !important"
          },
          attrs: {
            "type": "submit"
          }
        }, [_vm._v(_vm._s(_vm.isProcessing ? 'Processing' : 'Update'))])])])])])];
      }
    }])
  }), _vm.showOtpModal ? _c('EnrollmentOTPModal', {
    attrs: {
      "identifier": _vm.contactInfo,
      "identifierTypeText": _vm.otpType
    },
    on: {
      "save": _vm.handleVerificationResult,
      "close": _vm.closeOtpModal
    },
    model: {
      value: _vm.showOtpModal,
      callback: function callback($$v) {
        _vm.showOtpModal = $$v;
      },
      expression: "showOtpModal"
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }